import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';
import { apiUc, apiAuth } from '../../../http';

class UserService extends ServiceCRUD {
  constructor() {
    super('/api/usuarios');
  }

  getAllSeachUser(
    page,
    size,
    query,
    showDisable,
    login,
    sortBy,
    order,
    relations
  ) {
    return apiUc.get(`${this.path}?q=${query}&showDisable=${showDisable}`, {
      headers: {
        limit: size,
        offset: size * (page - 1),
        login
      },
      params: {
        order: order?.toUpperCase(),
        sortBy: sortBy,
        relations: relations
      }
    });
  }

  changeActive(login, data) {
    return apiUc.put(`${this.path}/${login}/status`, data);
  }

  changePassword(login, data) {
    return apiAuth.put(`/atualizar/${login}/senha`, data);
  }

  search(params) {
    return apiUc.get(`${this.path}`, {
      params
    });
  }

  async findAgentsMyTeam(login) {
    const response = await apiUc.get(`${this.path}/acessiveis/${login}`);
    return response.data;
  }
  usersForQueues(login) {
    return apiUc.get(`${this.path}/queues/${login}`);
  }

  updateUserQueue(login, data) {
    return apiUc.put(`${this.path}/queues/${login}`, data);
  }
}

export default new UserService();
